module.exports = __webpack_public_path__ + "static/img/cus-service.a636412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/pic/cus-service.png
// module id = hY/L
// module chunks = 11